export const Logo = ({ color = '#A259FF' }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_611_2798)">
        <g clipPath="url(#clip1_611_2798)">
          <path
            d="M23.9959 32H8.00411C3.58295 32 0 28.4171 0 23.9959V8.00411C0 3.58295 3.58295 0 8.00411 0H23.9959C28.4171 0 32 3.58295 32 8.00411V23.9959C32 28.4171 28.4171 32 23.9959 32Z"
            fill={color}
          />
          <path
            d="M13.2634 18.9012V10.1081C13.2634 9.82873 13.0333 9.61507 12.7703 9.61507H10.4693C10.305 9.61507 10.1406 9.69725 10.0584 9.82873L8.64497 11.9489C8.41487 12.2941 8.6614 12.7378 9.07229 12.7378H9.68041C9.95981 12.7378 10.2063 12.9679 10.2063 13.2638V23.2895C10.2063 23.5689 10.4364 23.799 10.7158 23.799H14.0194C14.2166 23.799 14.3974 23.7003 14.496 23.5524L23.3548 10.4697C23.6013 10.0917 23.3383 9.59863 22.8946 9.59863H20.61C20.4292 9.59863 20.2485 9.69725 20.1498 9.84517L13.9043 19.0819C13.7071 19.3778 13.2634 19.2299 13.2634 18.9012Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_611_2798">
          <rect width="32" height="32" fill="white" />
        </clipPath>
        <clipPath id="clip1_611_2798">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
